module.exports = __webpack_public_path__ + "img/boxes-stacked.46acb5c6.svg";